:host{position:relative;display:block;height:100%}.loading-backdrop{background:#fff;display:flex;justify-content:center;align-items:center}.overlay-loader{position:relative;top:2px}
/*# sourceMappingURL=loading-overlay.component.css.map */
